import injectBannersToEntities from './inject-banners-to-entities';

export default function getEntitiesWithBanner(entities, options, hasNewBannerSettings) {
  const { hasBanner } = options;
  if (hasNewBannerSettings) {
    return entities.map(currentEntity => {
      const { parent, transform, limit, banner } = options;
      const { adunit, baseAdunit } = banner || {};
      return { ...currentEntity, parent, limit, transform, adunit, baseAdunit };
    });
  }
  if (!hasBanner) return entities;

  return injectBannersToEntities(entities, options);
}
